/* eslint-disable global-require */

module.exports = {
	common: require("./common.json"),
	header: require("./header.json"),
	footer: require("./footer.json"),
	graphql: require("./graphql.json"),
	"how-to-buy": require("./how-to-buy-page.json"),
	"registration-form": require("./registration-form.json"),
	account: require("./account.json"),
	links: require("./links.json"),
	preferences: require("./preferences.json"),
	pricing: require("./pricing.json"),

	"404-page": require("./404-page.json"),

	"forgot-password-form": require("./forgot-password-form.json"),
	"forgot-password-page": require("./forgot-password-page.json"),
	"forgot-password-success-page": require("./forgot-password-success-page.json"),

	"reset-password-form": require("./reset-password-form.json"),
	"reset-password-page": require("./reset-password-page.json"),
	"reset-password-success-page": require("./reset-password-success-page.json"),
	"reset-password-fail-page": require("./reset-password-fail-page.json"),

	"login-page": require("./login-page.json"),
	"auth-login-form": require("./auth-login-form.json"),

	"configure-subscription": require("./configure-subscription.json"),

	"purchase-billing": require("./purchase-billing.json"),
	"purchase-confirm-renewal": require("./purchase-confirm-renewal"),
	"purchase-payment": require("./purchase-payment.json"),
	"purchase-activations": require("./purchase-activations.json"),

	"billing-info-form": require("./billing-info-form.json"),
	invoice: require("./invoice.json"),
	"cart-details": require("./cart-details.json"),
	"credit-card-form": require("./credit-card-form.json"),
	"payment-errors": require("./payment-errors"),
	"paypal-form": require("./paypal-form.json"),
	subscriptions: require("./subscriptions.json"),
	"subscription-billing": require("./subscription-billing.json"),
	"subscriptions-billing-activations": require("./subscriptions-billing-activations.json"),
	"subscription-cancel": require("./subscription-cancel.json"),
	"subscription-cancel-survey": require("./subscription-cancel-survey.json"),
	"subscriptions-change-payment-method": require("./subscriptions-change-payment-method"),
	"subscriptions-change-plan": require("./subscriptions-change-plan.json"),
	"change-payment-method-form": require("./change-payment-method-form"),
	"subscription-settings": require("./subscription-settings.json"),
	"subscription-dashboard": require("./subscription-dashboard.json"),
	"subscription-activations": require("./subscription-activations.json"),
	"add-alternate-admin-form": require("./add-alternate-admin-form.json"),
	"renew-subscription": require("./renew-subscription.json"),
	"subscription-billing-info-update-form": require("./subscription-billing-info-update-form.json"),
	"free-trial-upgrade-plan": require("./free-trial-upgrade-plan.json"),

	"pay-invoice-online": require("./pay-invoice-online.json"),

	"free-trial": require("./free-trial.json"),
	"free-trial-complete-profile": require("./free-trial-complete-profile.json"),
	"free-trial-upgrade-payment": require("./free-trial-upgrade-payment.json"),
	"privacy-policy": require("./privacy-policy.json"),
	legal: require("./legal.json"),
	"contact-us": require("./contact-us.json"),
	"section-try-for-free": require("./section-try-for-free.json"),
	"features-page": require("./features-page.json"),
};
